/**
 * VoiceFields — shared controlled component for Voz section.
 *
 * Used by both VoiceStep (wizard) and Perfil (full-edit page) so validation
 * and shape never drift.
 */

import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { ChipInput } from "../fields/ChipInput";

export interface VoiceFieldsValues {
  tone_formality: number;
  banned_words: string[];
  anchor_words: string[];
  example_phrases: string[];
}

export interface VoiceFieldsProps {
  value: VoiceFieldsValues;
  onChange: (patch: Partial<VoiceFieldsValues>) => void;
}

export function VoiceFields({ value, onChange }: VoiceFieldsProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label>Tom de formalidade</Label>
          <span className="text-sm tabular-nums text-muted-foreground">
            {value.tone_formality} / 10
          </span>
        </div>
        <Slider
          min={0}
          max={10}
          step={1}
          value={[value.tone_formality]}
          onValueChange={(v) => onChange({ tone_formality: v[0] })}
        />
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>Coloquial</span>
          <span>Formal</span>
        </div>
      </div>

      <div className="space-y-1.5">
        <Label>Palavras banidas</Label>
        <ChipInput
          value={value.banned_words}
          onChange={(v) => onChange({ banned_words: v })}
          placeholder="palavra que você nunca usa, Enter para adicionar"
          variant="destructive"
          ariaLabel="Palavras banidas"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Palavras-âncora</Label>
        <ChipInput
          value={value.anchor_words}
          onChange={(v) => onChange({ anchor_words: v })}
          placeholder="palavra que você sempre usa, Enter para adicionar"
          ariaLabel="Palavras-âncora"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Frases de exemplo</Label>
        <ChipInput
          value={value.example_phrases}
          onChange={(v) => onChange({ example_phrases: v })}
          placeholder="frase típica sua, Enter para adicionar"
          ariaLabel="Frases de exemplo"
        />
        <p className="text-xs text-muted-foreground">
          Pelo menos 1 frase. Quanto mais natural, melhor a IA imita.
        </p>
      </div>
    </div>
  );
}
